"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _tuiChart = _interopRequireDefault(require("tui-chart"));

var _ErrorBoundary = _interopRequireDefault(require("../components/ErrorBoundary"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Chart = /*#__PURE__*/function (_React$Component) {
  _inherits(Chart, _React$Component);

  var _super = _createSuper(Chart);

  function Chart() {
    var _this;

    _classCallCheck(this, Chart);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    return _this;
  }

  _createClass(Chart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var container = document.getElementById("chart-area");
      console.log("container", container);
      var data = {
        categories: ["Browser"],
        series: this.props.chartData
      };
      var options = {
        chart: {
          width: this.props.chartWidth,
          height: this.props.chartHeight,
          title: this.props.title,
          format: function format(value, chartType, areaType, valuetype, legendName) {
            if (areaType === "makingSeriesLabel") {
              // formatting at series area
              value = value + "%";
            }

            return value;
          }
        },
        series: {
          radiusRange: this.props.chartRadiusRange,
          showLabel: this.props.showChartLabel
        },
        tooltip: {
          suffix: "%"
        },
        legend: {
          align: this.props.legendAlignment
        }
      };
      var theme = this.props.chartThemeConfig; // tui.chart.registerTheme('newTheme', theme);
      // For apply theme

      _tuiChart["default"].registerTheme("myTheme", theme);

      options.theme = "myTheme";

      _tuiChart["default"].pieChart(container, data, options);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var container = document.getElementById("chart-area");
      container.innerHTML = "";
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_ErrorBoundary["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
        id: "chart-area"
      }));
    }
  }]);

  return Chart;
}(_react["default"].Component);

Chart.defaultProps = {
  name: "Stranger",
  chartData: [{
    name: "Chrome",
    data: 46.02
  }, {
    name: "IE",
    data: 20.47
  }, {
    name: "Firefox",
    data: 17.71
  }, {
    name: "Safari",
    data: 5.45
  }, {
    name: "Opera",
    data: 3.1
  }, {
    name: "Etc",
    data: 7.25
  }],
  chartWidth: 700,
  chartHeight: 700,
  title: "Usage share of web browsers",
  chartRadiusRange: ["60%", "100%"],
  showChartLabel: true,
  legendAlignment: "bottom",
  chartThemeConfig: {}
};
var _default = Chart;
exports["default"] = _default;